import RenderTypeProvider, { useRenderTypeContext } from './RenderTypeProvider';

export { useRenderTypeContext };
export default RenderTypeProvider;
